import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SIZE = 20;
const CurrentBlock = ({
    currentCycles1,
    currentCycles2,
    currentCycles3,
    currentCycles4,
    currentCycles5,
    currentCycles6,
    grid
}) => { 
    let rects = [];
    
    let currentCycles = [
        currentCycles1,
        currentCycles2,
        currentCycles3,
        currentCycles4,
        currentCycles5,
        currentCycles6].filter(x => x).flatMap(x => x);

    currentCycles.forEach(
        cycle => {
            for (let rule of cycle.rules) {
                if (!grid.rules || !grid.rules.includes(rule)) {
                    continue;
                }
                let block = rule.block;
                if (block) {
                    let minX = Math.min(... block.map(({x}) => x));
                    let minY = Math.min(... block.map(({y}) => y));
                    let maxX = Math.max(... block.map(({x}) => x));
                    let maxY = Math.max(... block.map(({y}) => y));
                    if (rects.some(rect => rect.x === minX*SIZE &&
                                   rect.y === minY*SIZE)) {
                        continue;
                    }
                    rects.push({
                        x: minX*SIZE,
                        y: minY*SIZE,
                        w: (1 + maxX - minX)*SIZE,
                        h: (1 + maxY - minY)*SIZE
                    });
                }
            }
        });
    return (
         <svg>
           {rects.map(
               r => <rect x={r.x} y={r.y} width={r.w} height={r.h} />)}
         </svg>
     );
 }

 const mapStateToProps = (state, props) => {
     let tidals = [
         props.grid.getConnectedTidal(0),
         props.grid.getConnectedTidal(1),
         props.grid.getConnectedTidal(2),
         props.grid.getConnectedTidal(3),
         props.grid.getConnectedTidal(4),
         props.grid.getConnectedTidal(5)];
         
     return {
         currentCycles1: tidals[0] && tidals[0].currentLeaves,
         currentCycles2: tidals[1] && tidals[1].currentLeaves,
         currentCycles3: tidals[2] && tidals[2].currentLeaves,
         currentCycles4: tidals[3] && tidals[3].currentLeaves,
         currentCycles5: tidals[4] && tidals[4].currentLeaves,
         currentCycles6: tidals[5] && tidals[5].currentLeaves,
     };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentBlock);
